import Grid from "../Grid/grid";
import Process from "../process";
import Title from "../title";
import rubyOnRailsDevelopmentProcess from "./data/ror-development-data";
import ror from "../../Assets/image/services-pages-images/ror/ror-content.webp";

function RORProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={rubyOnRailsDevelopmentProcess}
        img={ror}
        title="Ruby On Rails Development"
        description="Building Scalable & High-Performance Web Apps – Ruby on Rails Solutions Tailored for Your Success."
      />
    </section>
  );
}

export default RORProcess;
